/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Type from './Type/index'
import Value from './Value/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/ReferralsSection/Referrals/Referral/Kind/Person/Patient/Content"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Horizontal}`}
>
<Type
  viewPath={`${viewPath}/Type`}
/>
<Value
  viewPath={`${viewPath}/Value`}
/>
</div>
{children}
</React.Fragment>)
}